import MaxWidthWrapper from "./max-width-wrapper"
import ModalWrapper from "./modal-wrapper"
import ShadowBoxWrapper from "./shadow-box-wrapper"
import TabButtonWrapper from "./tab-button-wrapper"

const Wrapper = {
  maxWidth: MaxWidthWrapper,
  tab: TabButtonWrapper,
  shadow: ShadowBoxWrapper,
  modal: ModalWrapper
}

export default Wrapper
